import { ArrowLeft } from "lucide-react";
import { useNavigate, useLocation } from "react-router-dom";

// v36 — small "back to previous page" chip used across every Creator
// Intel page (affiliated + unaffiliated: lists, profiles, Alerts and
// Market Moves). Calls `navigate(-1)` so React Router pops the history
// entry — the previous page remounts from its own cached state, so
// scroll position and in-URL filters survive without a full reload.
//
// Hides itself when the user landed directly on this URL (no history
// to pop) unless a `fallback` route is supplied, in which case the
// chip appears and navigates to the fallback instead. Keeps the UI
// clean on bookmarks / direct-shares.
export default function BackLink({
  label = "Back",
  fallback = null,
  testid = "back-link",
  className = "",
}) {
  const nav = useNavigate();
  const location = useLocation();
  // react-router's `useLocation()` carries a `key`; on the very first
  // entry the key is "default" or the index is zero. We also look at
  // `window.history.length` as a secondary signal.
  const canGoBack = (location.key && location.key !== "default") || (typeof window !== "undefined" && window.history.length > 1);
  if (!canGoBack && !fallback) return null;
  const handle = () => {
    if (canGoBack) nav(-1);
    else if (fallback) nav(fallback);
  };
  return (
    <button
      type="button"
      data-testid={testid}
      onClick={handle}
      className={`inline-flex items-center gap-1.5 text-xs text-zinc-400 hover:text-white transition-colors ${className}`}
    >
      <ArrowLeft size={13} /> {label}
    </button>
  );
}
